module.exports = new __parcel__URL__("paid-version.d721ef56.png").toString();